<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>User Activity</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="account-body">
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head" data-width="20%">Date</div>
                                    <div class="results-head" data-width="30%">Activity</div>
                                    <div class="results-head" data-width="50%"></div>
                                </div>
                                <template v-if="activities.length > 0">
                                    <div class="results-row" v-for="(activity, index) in activities" :key="index"
                                         @click="handleViewActivity(activity)">
                                        <div class="results-cell" data-width="20%">
                                            {{ formatDateRelative(activity.datetime) }}
                                        </div>
                                        <div class="results-cell" data-width="30%">{{
                                                getActivityType(activity.type)
                                            }}
                                        </div>
                                        <div class="results-cell" data-width="50%">{{ activity.title }}</div>
                                    </div>
                                </template>
                                <div class="results-row" v-if="activities.length === 0">
                                    <div class="results-span text-center" data-width="100%">
                                        <p v-if="loading">Loading...</p>
                                        <p v-else>No recent activity</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>

            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
import Permissions from "../../../mixins/Permissions"

export default {
    name: "UsersActivity",
    mixins: [
        Permissions
    ],
    data() {
        return {
            activities: [],
            loading: false,
        }
    },
    mounted() {
        this.setMetaTitle('User Activity | JournoLink Control')
        this.loading = true
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get(route('users.activity', this.$route.params.userId))
                .then(response => {
                    this.activities = response.data.activity ?? []
                    this.loading = false
                })
                .catch(e => {
                    console.error({e})
                    this.loading = false
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Parse and Reword Activity Type
         *
         * @param type
         */
        getActivityType(type) {
            switch (type) {
                case 'JournoLink\\Shared\\Models\\PressRelease':
                    return 'Press Release Published'
                case 'JournoLink\\Shared\\Models\\MediaRequest':
                    return 'Media Request Submitted'
                case 'JournoLink\\Shared\\Models\\MediaRequestResponse':
                    return 'Media Request Response'
                case 'JournoLink\\Shared\\Models\\PressReleaseView':
                    return 'Viewed Press Release'
                case 'JournoLink\\Shared\\Models\\ProfessionalWriting':
                    return 'Professional Writing Request'
                default:
                    return 'Activity'
            }
        },
        /**
         * Navigate to Activity
         *
         * @param activity
         */
        handleViewActivity(activity) {
            switch (activity.type) {
                case 'JournoLink\\Shared\\Models\\PressRelease':
                case 'JournoLink\\Shared\\Models\\PressReleaseView':
                    if (this.allows('releases')) {
                        return this.$router.push({name: 'releases.show', params: {releaseId: activity.id}})
                    }
                    return
                case 'JournoLink\\Shared\\Models\\MediaRequest':
                    if (this.allows('media-requests')) {
                        return this.$router.push({
                            name: 'mediarequests.show',
                            params: {mediaRequestId: activity.id}
                        })
                    }
                    return
                case 'JournoLink\\Shared\\Models\\MediaRequestResponse':
                    if (this.allows('media-requests')) {
                        return this.$router.push({
                            name: 'mediarequests.show',
                            params: {mediaRequestId: activity.id}
                        })
                    }
                    return
                case 'JournoLink\\Shared\\Models\\ProfessionalWriting':
                    if (this.allows('professional-writing')) {
                        return this.$router.push({
                            name: 'professionalWriting.show',
                            params: {professionalWritingId: activity.id}
                        })
                    }
                default:
                    return
            }
        }
    }
}
</script>

<style lang="less">
.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
